import { InputText } from "primereact/inputtext";
import { useEffect, useState, useRef } from "react";

function TextEditor({
    data,
    label,
    placeholder,
    onBlur = () => { },
    trim,
    message,
    attr,
    refEl,
    ...params
}) {
    const [value, setValue] = useState(data?.[attr]);
    const timeoutRef = useRef(null);

    function onChange(e) {
        const val = trim ? e.target.value.trim() : e.target.value;
        setValue(val);

        // Очистить предыдущий таймер
        clearTimeout(timeoutRef.current);

        // Установить новый таймер
        timeoutRef.current = setTimeout(() => {
            onBlur(e, attr, val);
        }, 500); // или 1000 для 1 секунды
    }

    useEffect(() => {
        setValue(data?.[attr]);
    }, [data?.[attr]]);

    useEffect(() => {
        return () => clearTimeout(timeoutRef.current); // очистка при размонтировании
    }, []);

    return (
        <div className="flex justify-content-center">
            <div className="editor">
                {label && <label className="editor_label" htmlFor={label}>{label}</label>}
                <InputText
                    className={"p-inputtext-sm " + (params?.lagre ? "big-inp" : "")}
                    id={label}
                    aria-describedby="username-help"
                    placeholder={placeholder}
                    value={value}
                    ref={refEl}
                    onChange={onChange}
                    {...params}
                />
                {message && <small id="username-help">{message}</small>}
            </div>
        </div>
    );
}

export default TextEditor;
